import { render, staticRenderFns } from "./tenants-table.vue?vue&type=template&id=6d029f70&"
import script from "./tenants-table.vue?vue&type=script&lang=ts&"
export * from "./tenants-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d029f70')) {
      api.createRecord('6d029f70', component.options)
    } else {
      api.reload('6d029f70', component.options)
    }
    module.hot.accept("./tenants-table.vue?vue&type=template&id=6d029f70&", function () {
      api.rerender('6d029f70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/tenants/components/tenants-table.vue"
export default component.exports